import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest
} from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const getOrganisations = async (params?: any) => {
  const urlBuilder = createUrlBuilder(`/superadmin/organisation`).toString();

  return await getRequest(LocateService, urlBuilder, { params });
};

export const getOrganisationGroups = async () => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/groups`
  ).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const getOrganisationTransactionLimits = async (
  organisationId: number,
  params?: any
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}/transaction/limits`
  ).toString();

  return await getRequest(LocateService, urlBuilder, { params });
};

export const addOrganisationTransactionLimits = async (
  organisationId: number,
  payload: any
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}/transaction/limits`
  ).toString();

  return await postRequest(LocateService, urlBuilder, payload);
};

export const removeOrganisationTransactionLimits = async (
  organisationId: number,
  restrictionLimitId: number
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}/transaction/limits/${restrictionLimitId}`
  ).toString();

  return await deleteRequest(LocateService, urlBuilder);
};

export const updateMultiOrganisations = async (payload: any) => {
  const urlBuilder = createUrlBuilder(`/superadmin/organisation`).toString();
  return await putRequest(LocateService, urlBuilder, payload);
};

export const createNewOrganisation = async (data: any) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/new`
  ).toString();

  return await postRequest(LocateService, urlBuilder, data);
};

export const upgradeFreePlan = async (data: any) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/upgrade`
  ).toString();

  return await postRequest(LocateService, urlBuilder, data);
};

export const getOrganisationDetails = async (organisationId: number) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}`
  ).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const updateOrganisation = async (
  organisationId: number,
  payload: any
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}`
  ).toString();

  return await putRequest(LocateService, urlBuilder, payload);
};

export const suspendOrganisation = async (
  organisationId: number,
  payload: any
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}/suspend`
  ).toString();

  return await putRequest(LocateService, urlBuilder, payload);
};

export const deleteOrganisation = async (organisationId: number) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}`
  ).toString();

  return await deleteRequest(LocateService, urlBuilder);
};

export const getFreePlanUsers = async (params?: any) => {
  const urlBuilder = createUrlBuilder(`/superadmin/users`).toString();
  return await getRequest(LocateService, urlBuilder, { params });
};

export const getFreePlanUserDetails = async (params?: any) => {
  const { userId } = params;
  const urlBuilder = createUrlBuilder(`/superadmin/users/${userId}`).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const getOrganisationUpdateLogs = async (
  organisationId: number,
  params?: any
) => {
  const urlBuilder = createUrlBuilder(
    `/superadmin/organisation/${organisationId}/logs`
  ).toString();

  return await getRequest(LocateService, urlBuilder, { params });
};
